import { SEO_CABS_LANDING_PAGE } from './constants/templateConstants';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS,
  getShortCode
} from './constants/tripTypes';
import { CityLocation, Package } from './pages/runtime-typechecker';
import queryString from 'query-string';
const dayjs = require('dayjs');

export const MWEB_LISTING_URL = 'https://cabs.makemytrip.com/cabsListing';
const DATE_FROMAT = 'DD-MM-YYYY';

const createDeepLinkWithQueryObject = queryObject => {
  let source: string | null = SEO_CABS_LANDING_PAGE;
  let cmp: string | null = null;

  if (window?.location?.href != null) {
    const url = new URL(window.location.href);
    if (url.searchParams.get('source')) {
      source = url.searchParams.get('source');
    }
    //add source from URL or use SEO_CABS_LANDING_PAGE
    queryObject.source = source;

    if (url.searchParams.get('cmp')) {
      cmp = url.searchParams.get('cmp');
      //add cmp from URL
      queryObject.cmp = cmp;
    }
  }

  const lisingUrl = `${MWEB_LISTING_URL}?${queryString.stringify(queryObject)}`;

  return lisingUrl;
};

const getStopOverDetails = (stopOvers: CityLocation[]) => {
  const stopOverDetails = {};
  if (!stopOvers || stopOvers.length === 0) return stopOverDetails;

  stopOvers.forEach((cityLocation, idx) => {
    stopOverDetails[idx] = cityLocation.placeId;
  });
  return stopOverDetails;
};

export const cabsListingDeepLinkBuilder = ({
  travelFor,
  sourceCity,
  destinationCity,
  airport,
  airportCity,
  rentalCity,
  selectedDeptDate,
  selectedReturnDate,
  selectedHrPackage,
  airportRideNow,
  stopOvers
}: {
  travelFor: string;
  sourceCity: CityLocation | null;
  destinationCity: CityLocation | null;
  airport: CityLocation | null;
  airportCity: CityLocation | null;
  rentalCity: CityLocation | null;
  selectedDeptDate: Date;
  selectedReturnDate: Date;
  selectedHrPackage: Package | null;
  airportRideNow: boolean;
  stopOvers: CityLocation[];
}) => {
  const formatTime = (inputDate: Date) => {
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();
    return `${hours}:${minutes}`;
  };
  if (sourceCity?.city && sourceCity?.subText && sourceCity?.geoLocation) {
    sourceCity.geoLocation.address = `${sourceCity.city}, ${sourceCity.subText}`;
  }

  if (
    destinationCity?.city &&
    destinationCity?.subText &&
    destinationCity?.geoLocation
  ) {
    destinationCity.geoLocation.address = `${destinationCity.city}, ${destinationCity.subText}`;
  }
  switch (true) {
    case travelFor === OUTSTATION_ONE_WAY:
      return (() => {
        const queryObject = {
          tripType: getShortCode(travelFor),
          fromCity: JSON.stringify(sourceCity?.geoLocation),
          toCity: JSON.stringify(destinationCity?.geoLocation),
          departDate: dayjs(selectedDeptDate).format(DATE_FROMAT),
          pickupTime: formatTime(selectedDeptDate),
          returnDate: dayjs(selectedReturnDate).format(DATE_FROMAT),
          dropTime: formatTime(selectedReturnDate),
          stopsPlaceIds: JSON.stringify(getStopOverDetails(stopOvers))
        };
        return createDeepLinkWithQueryObject(queryObject);
      })();
    case travelFor === OUTSTATION_ROUND_TRIP:
      return (() => {
        const queryObject = {
          tripType: getShortCode(travelFor),
          fromCity: JSON.stringify(sourceCity?.geoLocation),
          toCity: JSON.stringify(destinationCity?.geoLocation),
          departDate: dayjs(selectedDeptDate).format(DATE_FROMAT),
          returnDate: dayjs(selectedReturnDate).format(DATE_FROMAT),
          pickupTime: formatTime(selectedDeptDate),
          dropTime: formatTime(selectedReturnDate),
          stopsPlaceIds: JSON.stringify(getStopOverDetails(stopOvers))
        };
        return createDeepLinkWithQueryObject(queryObject);
      })();
    case travelFor === CAB_FROM_AIRPORT:
      return (() => {
        const queryObject = {
          tripType: getShortCode(travelFor),
          // TO DO: needs to be refactored, Ideally based on trip type Location and Airport API apis needs to be called, true for CabsModifySearch.tsx
          fromCity: JSON.stringify({
            ...airport?.geoLocation,
            is_airport: true
          }),
          toCity: JSON.stringify(airportCity?.geoLocation),
          fromAirport: true,
          toAirport: false,
          departDate: dayjs(selectedDeptDate).format(DATE_FROMAT),
          pickupTime: formatTime(selectedDeptDate)
        };
        return createDeepLinkWithQueryObject(queryObject);
      })();
    case travelFor === CAB_TO_AIRPORT:
      return (() => {
        const queryObject = {
          tripType: getShortCode(travelFor),
          fromCity: JSON.stringify(airportCity?.geoLocation),
          toCity: JSON.stringify({ ...airport?.geoLocation, is_airport: true }),
          fromAirport: false,
          toAirport: true,
          departDate: dayjs(selectedDeptDate).format(DATE_FROMAT),
          pickupTime: formatTime(selectedDeptDate)
        };
        return createDeepLinkWithQueryObject(queryObject);
      })();
    case travelFor === RENTALS:
      return (() => {
        const queryObject = {
          tripType: getShortCode(travelFor),
          fromCity: JSON.stringify(rentalCity?.geoLocation),
          pickupTime: formatTime(selectedDeptDate),
          packageKey: selectedHrPackage?.package_id || '',
          departDate: dayjs(selectedDeptDate).format(DATE_FROMAT)
        };
        return createDeepLinkWithQueryObject(queryObject);
      })();
  }
};
